"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSessionTypes = getSessionTypes;
exports.getInstructors = getInstructors;
exports.getReportcardTypes = getReportcardTypes;
exports.getDocumentTemplates = getDocumentTemplates;
exports.getSchoolTasks = getSchoolTasks;
/**
 * Lookup resolves shared by the Roadmap editor states: everything a lesson
 * row can reference (session types, instructors, report card types, active
 * document templates, and the school's report card skills).
 */
function getSessionTypes(DriveSessionTypesModel) {
    return DriveSessionTypesModel.get().then(function (response) {
        return response.sessionTypes;
    });
}
getSessionTypes.$inject = ["DriveSessionTypesModel"];
function getInstructors(UsersModel) {
    return UsersModel.getInstructors({ all: true, status: "Active" }).then(function (response) {
        return response.instructors;
    });
}
getInstructors.$inject = ["UsersModel"];
function getReportcardTypes(ReportcardsTypesModel) {
    return ReportcardsTypesModel.get().then(function (response) {
        return response.data;
    });
}
getReportcardTypes.$inject = ["ReportcardsTypesModel"];
function getDocumentTemplates(DocumentTemplateModel) {
    return DocumentTemplateModel.getTemplates().then(function (response) {
        return (response.data || []).filter(function (template) { return template.status === "active"; });
    });
}
getDocumentTemplates.$inject = ["DocumentTemplateModel"];
function getSchoolTasks(SchoolsModel, UserService) {
    return SchoolsModel.getTasks(UserService.getCurrentUser().school_id).then(function (response) {
        return response.tasks;
    });
}
getSchoolTasks.$inject = ["SchoolsModel", "UserService"];
